import { FILTER_KEYS} from 'config/constants';
import { useRouter } from 'helpers/customHooks';
import React from 'react';
import { useFiltersDispatch, useFiltersState, useUserState } from 'store/hooks';
import { useEntitiesDispatch } from 'store/hooks/entities';
import EntitiesBody from './EntitiesBody';
import { EntitiesWrapperProps } from './types';

const EntitiesBodyWrapper = (props:EntitiesWrapperProps) => {
  const { specificScope } = useRouter();
  const { [FILTER_KEYS.VENUE]: venue } = useFiltersState(specificScope, FILTER_KEYS.VENUE);
  const user = useUserState();
  const teamId = props.isToday? props.teamId? props.teamId : venue?.value.teamId || user.teamId : venue?.value.teamId || user.teamId;
  const { getEntities, createEntity, editEntity, deleteEntity } = useEntitiesDispatch();
  const { loadTeams } = useFiltersDispatch();
  const newProps = {
    ...props,
    teamId,
    loadEntities: getEntities,
    createEntity,
    editEntity,
    deleteEntity,
    loadTeams,
  };

  return <EntitiesBody {...newProps}/>;
};

export default EntitiesBodyWrapper;
